export  function addTimestampToFile(file: File): File {
    const timestamp = Date.now(); // Get current timestamp
    const fileName = `${timestamp}_${file.name}`; // Add timestamp to file name
    return new File([file], fileName, { type: file.type }); // Create a new file object with timestamped name
  }